// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}.template-wrapper{background-color:#fff;box-sizing:border-box;position:relative;overflow:hidden}.template-wrapper-mt{margin-top:120px}\n", ""]);
// Exports
module.exports = exports;
